import * as React from 'react'

import { BlankSlate, Box, Icon } from '@factorialco/deprecated-design-system'

interface Props {
  message: string
  description?: string
  illustration: React.ComponentProps<typeof Icon.Large>['icon']
}

const ReportBlankSlate = ({
  message,
  description,
  illustration,
  children,
}: React.PropsWithChildren<Props>) => (
  <Box justifyContent="center" height="full">
    <BlankSlate title={message} description={description} illustration={illustration} size="small">
      {children}
    </BlankSlate>
  </Box>
)

export default ReportBlankSlate
